import DeleteOrderModule from './DeleteOrder.module';

export * from './DeleteOrderModuleProps';
export default DeleteOrderModule;
